module.exports = __webpack_public_path__ + "media/images/flags/64/Guyana-9c423309bbecb7a1fda5eebf4dacb8d5.png";